"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigAppSettings = void 0;
var React = require("react");
var Icons_1 = require("office-ui-fabric-react/lib/Icons");
var microsoftTeams = require("@microsoft/teams-js");
var react_northstar_1 = require("@fluentui/react-northstar");
var react_icons_northstar_1 = require("@fluentui/react-icons-northstar");
var config_api_1 = require("../../api/config-api");
var serventias_api_1 = require("../../api/serventias-api");
var meetings_api_1 = require("../../api/meetings-api");
require("./config-app.scss");
var data_1 = require("../../constants/data");
var pesquisa_satisfacao_1 = require("../../constants/pesquisa-satisfacao");
var common_helper_1 = require("../../helpers/common-helper");
var image_helper_1 = require("../../helpers/image-helper");
var loaderConfigApp_1 = require("../loaders/loaderConfigApp");
var ConfigAppSettings = /** @class */ (function (_super) {
    __extends(ConfigAppSettings, _super);
    function ConfigAppSettings(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Setup App
         * */
        _this.setupApp = function () { return __awaiter(_this, void 0, void 0, function () {
            var responseSetup;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, serventias_api_1.getAppSetup()];
                    case 1:
                        responseSetup = _a.sent();
                        if (responseSetup) {
                            this.setState({
                                setup: responseSetup.data
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.isSaveBtnDisabled = function () {
            return !(_this.state.isValidUrlAjudaComoFunciona &&
                _this.state.isValidUrlAjudaPerguntasFrequentes &&
                _this.state.isValidHorarioInicial &&
                _this.state.isValidHorarioFinal &&
                _this.state.isValidHorario &&
                _this.state.isValidUrlPesquisaExterna);
        };
        _this.onSave = function () {
            var _a;
            var diasAtendimento = "";
            (_a = _this.state.diasAtendimento) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
                if (diasAtendimento) {
                    diasAtendimento += ", " + item.key;
                }
                else {
                    diasAtendimento = item.key;
                }
            });
            var groupData = {
                gestores: _this.state.selectedGestoresId,
                atendentes: _this.state.selectedAtendentesId,
                horarioAtendimentoInicial: _this.state.horarioAtendimentoInicial,
                horarioAtendimentoFinal: _this.state.horarioAtendimentoFinal,
                horarioAtendimentoDias: diasAtendimento,
                ajudaComoFunciona: _this.state.ajudaComoFunciona,
                ajudaPerguntasFrequentes: _this.state.ajudaPerguntasFrequentes,
                pesquisaSatisfacao: _this.state.pesquisaSatisfacao,
                urlPesquisaSatisfacaoExterna: _this.state.urlPesquisaSatisfacaoExterna,
                tiposCategorias: _this.state.listTiposCategorias,
            };
            config_api_1.setAppSettings(groupData).then(function () {
                microsoftTeams.tasks.submitTask();
            });
        };
        _this.getGroupData = function (userId) { return __awaiter(_this, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, config_api_1.getUserGroups(userId)];
                    case 1:
                        response = _a.sent();
                        this.setState({
                            groups: response.data
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, error_1];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.onGroupSearch = function (itemList, searchQuery) {
            var result = itemList.filter(function (item) { return (item.header && item.header.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1) ||
                (item.content && item.content.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1); });
            return result;
        };
        _this.onGroupSearchQueryChange = function (event, itemsData) { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                if (!itemsData.searchQuery) {
                    this.setState({
                        noResultMessage: "",
                    });
                }
                else if (itemsData.searchQuery && itemsData.searchQuery.length <= 2) {
                    this.setState({
                        loading: false,
                        noResultMessage: "Nenhuma ocorrência encontrada.",
                    });
                }
                else if (itemsData.searchQuery && itemsData.searchQuery.length > 2) {
                    result = itemsData.items && itemsData.items.find(function (item) { return item.header.toLowerCase() === itemsData.searchQuery.toLowerCase(); });
                    if (result) {
                        return [2 /*return*/];
                    }
                }
                return [2 /*return*/];
            });
        }); };
        _this.onGestoresChange = function (event, itemsData) {
            if (itemsData.value.length > 1)
                _this.setState({
                    selectedGestores: itemsData.value[1],
                    selectedGestoresId: itemsData.value[1].key,
                });
            else
                _this.setState({
                    selectedGestores: itemsData.value[0],
                    selectedGestoresId: (itemsData === null || itemsData === void 0 ? void 0 : itemsData.value.length) ? itemsData.value[0].key : "",
                });
        };
        _this.onAtendentesChange = function (event, itemsData) {
            if (itemsData.value.length > 1)
                _this.setState({
                    selectedAtendentes: itemsData.value[1],
                    selectedAtendentesId: itemsData.value[1].key,
                });
            else
                _this.setState({
                    selectedAtendentes: itemsData.value[0],
                    selectedAtendentesId: (itemsData === null || itemsData === void 0 ? void 0 : itemsData.value.length) ? itemsData.value[0].key : "",
                });
        };
        _this.onTipoCategoriaChange = function (event) {
            _this.setState({
                tipoCategoria: event.target.value,
            });
        };
        _this.onHorarioInicialChange = function (event, itemData) {
            var isValidHorario = true;
            var isValidHorarioInicial = true;
            if (itemData.value && _this.state.horarioAtendimentoFinal) {
                var horarioInicial = itemData.value.replace(":", "");
                var horarioFinal = _this.state.horarioAtendimentoFinal.replace(":", "");
                if (Number(horarioInicial) >= Number(horarioFinal)) {
                    isValidHorarioInicial = false;
                }
                else {
                    isValidHorarioInicial = true;
                    _this.setState({ isValidHorarioFinal: true });
                }
            }
            else if (itemData.value) {
                isValidHorario = false;
            }
            _this.setState({
                horarioAtendimentoInicial: itemData.value == null ? "" : itemData.value,
                isValidHorarioInicial: isValidHorarioInicial,
                isValidHorario: isValidHorario
            });
        };
        _this.onHorarioFinalChange = function (event, itemData) {
            var isValidHorario = true;
            var isValidHorarioFinal = true;
            if (itemData.value && _this.state.horarioAtendimentoInicial) {
                var horarioFinal = itemData.value.replace(":", "");
                var horarioInicial = _this.state.horarioAtendimentoInicial.replace(":", "");
                if (Number(horarioInicial) >= Number(horarioFinal)) {
                    isValidHorarioFinal = false;
                }
                else {
                    isValidHorarioFinal = true;
                    _this.setState({ isValidHorarioInicial: true });
                }
            }
            else if (itemData.value) {
                isValidHorario = false;
            }
            _this.setState({
                horarioAtendimentoFinal: itemData.value == null ? "" : itemData.value,
                isValidHorarioFinal: isValidHorarioFinal,
                isValidHorario: isValidHorario
            });
        };
        _this.onDiasAtendimentoChange = function (event, itemsData) {
            _this.setState({
                diasAtendimento: itemsData.value
            });
        };
        _this.onAjudaComoFuncionaChange = function (event, itemsData) {
            var isValidUrlAjudaComoFunciona = true;
            if (itemsData.value) {
                isValidUrlAjudaComoFunciona = common_helper_1.CommonHelper.validUrl(itemsData.value);
            }
            else {
                isValidUrlAjudaComoFunciona = true;
            }
            _this.setState({
                ajudaComoFunciona: itemsData.value,
                isValidUrlAjudaComoFunciona: isValidUrlAjudaComoFunciona,
            });
        };
        _this.onAjudaPerguntasFrequentesChange = function (event, itemsData) {
            var isValidUrlPerguntasFrequentes = true;
            if (itemsData.value) {
                isValidUrlPerguntasFrequentes = common_helper_1.CommonHelper.validUrl(itemsData.value);
            }
            else {
                isValidUrlPerguntasFrequentes = true;
            }
            _this.setState({
                ajudaPerguntasFrequentes: itemsData.value,
                isValidUrlAjudaPerguntasFrequentes: isValidUrlPerguntasFrequentes,
            });
        };
        _this.onPesquisaSatisfacaoChange = function (event, itemsData) {
            _this.setState({
                pesquisaSatisfacao: itemsData.value,
                urlPesquisaSatisfacaoExterna: "",
                isValidUrlPesquisaExterna: itemsData.value == pesquisa_satisfacao_1.default.pesquisaExterna ? false : true,
            });
        };
        _this.onUrlPesquisaSatisfacaoExternaChange = function (event, itemsData) {
            var isValidUrlPesquisaExterna = false;
            if (itemsData.value) {
                isValidUrlPesquisaExterna = common_helper_1.CommonHelper.validUrl(itemsData.value);
            }
            else {
                isValidUrlPesquisaExterna = false;
            }
            _this.setState({
                urlPesquisaSatisfacaoExterna: itemsData.value,
                isValidUrlPesquisaExterna: isValidUrlPesquisaExterna
            });
        };
        _this.addTipoCategoria = function (tipoCategoria) {
            var tiposCategorias = _this.state.listTiposCategorias || [];
            tiposCategorias.push(tipoCategoria);
            _this.setState({
                listTiposCategorias: tiposCategorias,
                tipoCategoria: "",
            });
        };
        _this.deleteTipoCategoria = function (tipoCategoria, index) {
            var indexTipoCategoria = _this.state.listTiposCategorias.indexOf(tipoCategoria);
            if (indexTipoCategoria > -1) {
                _this.state.listTiposCategorias.splice(indexTipoCategoria, 1);
            }
            _this.setState({
                listTiposCategorias: _this.state.listTiposCategorias
            });
        };
        _this.makeDropdownItems = function (items) {
            var resultedTeams = [];
            if (items) {
                items.forEach(function (element) {
                    if (element.mail)
                        resultedTeams.push({
                            key: element.id,
                            header: element.displayName,
                            content: element.mail,
                            image: image_helper_1.ImageUtil.makeInitialImage(element.displayName),
                            team: {
                                id: element.id
                            },
                        });
                });
            }
            return resultedTeams;
        };
        Icons_1.initializeIcons();
        _this.state = {
            groups: [],
            selectedGestores: [],
            selectedGestoresId: "",
            selectedAtendentes: [],
            selectedAtendentesId: "",
            selectedGroupsNum: 0,
            noResultMessage: "",
            loading: false,
            loader: true,
            horarioAtendimentoInicial: "",
            horarioAtendimentoFinal: "",
            diasAtendimento: [],
            pesquisaSatisfacao: "",
            urlPesquisaSatisfacaoExterna: "",
            tipoCategoria: "",
            ajudaComoFunciona: "",
            isValidUrlAjudaComoFunciona: true,
            ajudaPerguntasFrequentes: "",
            isValidUrlAjudaPerguntasFrequentes: true,
            isValidUrlPesquisaExterna: true,
            listTiposCategorias: [],
            isValidHorarioInicial: true,
            isValidHorarioFinal: true,
            isValidHorario: true,
            appConfigs: null,
            itemsPesquisaSatisfacao: [],
            setup: null,
        };
        return _this;
    }
    ConfigAppSettings.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, id;
            var _this = this;
            return __generator(this, function (_a) {
                microsoftTeams.initialize();
                this.setupApp();
                this.getAppConfig();
                params = this.props.match.params;
                if ('id' in params) {
                    id = params['id'];
                    this.getGroupData(id).then(function (graphData) {
                        var selectedGroups = _this.makeDropdownItems(_this.state.groups);
                        config_api_1.getAppSettings().then(function (settingsData) {
                            if (settingsData.data) {
                                var diasAtendimento_1 = [];
                                if (settingsData.data.horarioAtendimentoDias && settingsData.data.horarioAtendimentoDias.length > 0) {
                                    var diasAtendimentoStr = settingsData.data.horarioAtendimentoDias.split(',');
                                    diasAtendimentoStr.forEach(function (item) {
                                        data_1.default.daysOfWeek.filter(function (day) {
                                            if (item.trim() == day.key) {
                                                diasAtendimento_1.push(day);
                                            }
                                        });
                                    });
                                }
                                _this.setState({
                                    selectedGestores: settingsData.data ? selectedGroups.filter(function (g) { return g.key == settingsData.data.gestores; }) : graphData.data,
                                    selectedGestoresId: settingsData.data.gestores,
                                    selectedAtendentes: settingsData.data ? selectedGroups.filter(function (g) { return g.key == settingsData.data.atendentes; }) : graphData.data,
                                    selectedAtendentesId: settingsData.data.atendentes,
                                    diasAtendimento: diasAtendimento_1,
                                    horarioAtendimentoInicial: settingsData.data.horarioAtendimentoInicial,
                                    horarioAtendimentoFinal: settingsData.data.horarioAtendimentoFinal,
                                    ajudaComoFunciona: settingsData.data.ajudaComoFunciona,
                                    ajudaPerguntasFrequentes: settingsData.data.ajudaPerguntasFrequentes,
                                    pesquisaSatisfacao: settingsData.data.pesquisaSatisfacao,
                                    urlPesquisaSatisfacaoExterna: settingsData.data.urlPesquisaSatisfacaoExterna,
                                    listTiposCategorias: settingsData.data.tiposCategorias,
                                    loader: false,
                                });
                            }
                            else {
                                _this.setState({
                                    loader: false,
                                });
                            }
                        });
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Get App Configs
     * */
    ConfigAppSettings.prototype.getAppConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, itensPesquisaSatisfacao;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, meetings_api_1.getAppConfig()];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            itensPesquisaSatisfacao = pesquisa_satisfacao_1.default.pesquisaSatisfacao;
                            if (response.data.ratingQuestions) {
                                itensPesquisaSatisfacao.push(pesquisa_satisfacao_1.default.pesquisaCustomizada);
                            }
                            this.setState({
                                appConfigs: response.data,
                                itemsPesquisaSatisfacao: itensPesquisaSatisfacao,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ;
    ConfigAppSettings.prototype.escFunction = function (event) {
        if (event.keyCode === 27 || (event.key === "Escape")) {
            microsoftTeams.tasks.submitTask();
        }
    };
    ConfigAppSettings.prototype.onCancel = function () {
        microsoftTeams.tasks.submitTask();
    };
    ConfigAppSettings.prototype.getGroupItems = function () {
        if (this.state.groups) {
            return this.makeDropdownItems(this.state.groups);
        }
        var dropdownItems = [];
        return dropdownItems;
    };
    ConfigAppSettings.prototype.renderTiposCategorias = function (item, index) {
        var _this = this;
        return {
            key: index,
            className: 'item-tipo-categoria',
            header: item,
            truncateHeader: true,
            endMedia: (React.createElement(react_icons_northstar_1.CloseIcon, { circular: true, size: "small", styles: { cursor: 'pointer' }, onClick: function () { return _this.deleteTipoCategoria(item, index); } }))
        };
    };
    ConfigAppSettings.prototype.render = function () {
        var _this = this;
        if (!this.state.loader) {
            return (React.createElement("div", { className: "taskModule" },
                React.createElement("div", { className: "formContainer" },
                    React.createElement("div", { className: "formContentContainer permissions" },
                        React.createElement("div", { className: "inputField" },
                            React.createElement(react_northstar_1.Text, { className: "label-field", content: "Gestores do Servi\u00E7o: " }),
                            React.createElement(react_northstar_1.Dropdown, { multiple: true, fluid: true, className: "hideToggle", placeholder: "Selecione um grupo M365", search: this.onGroupSearch, loading: this.state.loading, loadingMessage: "Carregando...", items: this.getGroupItems(), value: this.state.selectedGestores, onSearchQueryChange: this.onGroupSearchQueryChange, onChange: this.onGestoresChange, noResultsMessage: this.state.noResultMessage, unstable_pinned: true })),
                        React.createElement("div", { className: "inputField" },
                            React.createElement(react_northstar_1.Text, { className: "label-field", content: "Atendentes: " }),
                            React.createElement(react_northstar_1.Dropdown, { multiple: true, fluid: true, className: "hideToggle", placeholder: "Selecione um grupo M365", search: this.onGroupSearch, loading: this.state.loading, loadingMessage: "Carregando...", items: this.getGroupItems(), value: this.state.selectedAtendentes, onSearchQueryChange: this.onGroupSearchQueryChange, onChange: this.onAtendentesChange, noResultsMessage: this.state.noResultMessage, unstable_pinned: true })),
                        React.createElement(react_northstar_1.Flex, { column: true, "aria-disabled": !this.state.setup },
                            React.createElement(react_northstar_1.Flex, { space: "between" },
                                React.createElement(react_northstar_1.FlexItem, { size: "size.half" },
                                    React.createElement(react_northstar_1.Input, { className: "inputField", fluid: true, value: this.state.ajudaComoFunciona, label: "Ajuda/Como funciona Url: ", onChange: this.onAjudaComoFuncionaChange, error: this.state.ajudaComoFunciona != '' && !this.state.isValidUrlAjudaComoFunciona, errorIndicator: React.createElement(react_northstar_1.Tooltip, { content: "URL inválida" },
                                            React.createElement(react_icons_northstar_1.ExclamationCircleIcon, null)), disabled: !this.state.setup })),
                                React.createElement(react_northstar_1.FlexItem, { size: "size.half" },
                                    React.createElement(react_northstar_1.Input, { className: "inputField", fluid: true, value: this.state.ajudaPerguntasFrequentes, label: "Ajuda/Perguntas frequentes Url: ", onChange: this.onAjudaPerguntasFrequentesChange, error: this.state.ajudaPerguntasFrequentes != '' && !this.state.isValidUrlAjudaPerguntasFrequentes, errorIndicator: React.createElement(react_northstar_1.Tooltip, { content: "URL inválida" },
                                            React.createElement(react_icons_northstar_1.ExclamationCircleIcon, null)), disabled: !this.state.setup }))),
                            React.createElement("div", { className: "inputField" },
                                React.createElement(react_northstar_1.Text, { className: "label-field", content: "Dias de atendimento: " }),
                                React.createElement(react_northstar_1.Dropdown, { multiple: true, fluid: true, clearable: true, checkable: true, items: data_1.default.daysOfWeek, placeholder: "Selecione os dias de atendimento", onChange: this.onDiasAtendimentoChange, value: this.state.diasAtendimento, disabled: !this.state.setup })),
                            React.createElement(react_northstar_1.Flex, { space: "between" },
                                React.createElement(react_northstar_1.FlexItem, { size: "size.half" },
                                    React.createElement("div", { className: "inputField" },
                                        React.createElement(react_northstar_1.Text, { className: "label-field", content: "Hor\u00E1rios de atendimento: " }),
                                        React.createElement(react_northstar_1.Dropdown, { items: data_1.default.hoursStart, fluid: true, clearable: true, checkable: true, placeholder: "Selecione o hor\u00E1rio inicial", onChange: this.onHorarioInicialChange, value: this.state.horarioAtendimentoInicial, error: this.state.horarioAtendimentoInicial != '' && !this.state.isValidHorarioInicial, disabled: !this.state.setup }))),
                                React.createElement(react_northstar_1.FlexItem, { size: "size.half" },
                                    React.createElement("div", { className: "inputField" },
                                        React.createElement(react_northstar_1.Text, { className: "label-field", styles: { height: "18px" } }),
                                        React.createElement(react_northstar_1.Dropdown, { items: data_1.default.hoursEnd, fluid: true, clearable: true, checkable: true, placeholder: "Selecione o hor\u00E1rio final", onChange: this.onHorarioFinalChange, value: this.state.horarioAtendimentoFinal, error: this.state.horarioAtendimentoFinal != '' && !this.state.isValidHorarioFinal, disabled: !this.state.setup })))),
                            React.createElement("div", { className: "inputField" },
                                React.createElement(react_northstar_1.Text, { className: "label-field", content: "Pesquisa de satisfa\u00E7\u00E3o: " }),
                                React.createElement(react_northstar_1.Dropdown, { fluid: true, clearable: true, checkable: true, items: this.state.itemsPesquisaSatisfacao, placeholder: "Selecione o tipo da pesquisa de satisfa\u00E7\u00E3o", onChange: this.onPesquisaSatisfacaoChange, value: this.state.pesquisaSatisfacao, disabled: !this.state.setup })),
                            React.createElement("div", { className: "inputField", hidden: !(this.state.pesquisaSatisfacao == pesquisa_satisfacao_1.default.pesquisaExterna) },
                                React.createElement(react_northstar_1.Text, { className: "label-field", content: "Url pesquisa de satisfa\u00E7\u00E3o:* " }),
                                React.createElement(react_northstar_1.Input, { fluid: true, value: this.state.urlPesquisaSatisfacaoExterna, onChange: this.onUrlPesquisaSatisfacaoExternaChange, error: this.state.urlPesquisaSatisfacaoExterna != '' && !this.state.isValidUrlPesquisaExterna, errorIndicator: React.createElement(react_northstar_1.Tooltip, { content: "URL inválida" },
                                        React.createElement(react_icons_northstar_1.ExclamationCircleIcon, null)), disabled: !this.state.setup })),
                            React.createElement("div", { className: "inputField" },
                                React.createElement(react_northstar_1.Text, { className: "label-field", content: "Tipo/Categoria: " }),
                                React.createElement(react_northstar_1.Input, { icon: this.state.tipoCategoria ? React.createElement(react_icons_northstar_1.AddIcon, { styles: { cursor: "pointer" }, onClick: function () { return _this.addTipoCategoria(_this.state.tipoCategoria); } }) : React.createElement(React.Fragment, null), fluid: true, value: this.state.tipoCategoria, onChange: this.onTipoCategoriaChange, disabled: !this.state.setup })),
                            React.createElement("div", { className: "inputField" },
                                React.createElement(react_northstar_1.List, { items: this.state.listTiposCategorias ? this.state.listTiposCategorias.map(this.renderTiposCategorias.bind(this)) : [] }))))),
                React.createElement("div", { className: "footerContainer" },
                    React.createElement("div", { className: "buttonContainer" },
                        React.createElement(react_northstar_1.Button, { content: "Cancelar", id: "cancelBtn", onClick: this.onCancel }),
                        React.createElement(react_northstar_1.Button, { content: "Salvar", id: "saveBtn", onClick: this.onSave.bind(this), primary: true, disabled: this.isSaveBtnDisabled() })))));
        }
        else {
            return (React.createElement(loaderConfigApp_1.default, null));
        }
    };
    return ConfigAppSettings;
}(React.Component));
exports.ConfigAppSettings = ConfigAppSettings;
//# sourceMappingURL=config-app.js.map